// extracted by mini-css-extract-plugin
export default {"content":"closeaccount_content__mhYNL","closedAccountIcon":"closeaccount_closedAccountIcon__nXGc8"};